import { render, staticRenderFns } from "./RAverageStarRating.vue?vue&type=template&id=05515d01&scoped=true&"
import script from "./RAverageStarRating.vue?vue&type=script&lang=js&"
export * from "./RAverageStarRating.vue?vue&type=script&lang=js&"
import style0 from "./RAverageStarRating.vue?vue&type=style&index=0&id=05515d01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05515d01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDivider,VSkeletonLoader})
